/*
  ALLMEAT desktop nav dropdowns — T23/H7.

  The panels were already painted in the theme's tokens. What was missing is
  everything a dropdown does: `.am-drop` is a bare <details>/<summary> with no
  JavaScript at all, so it opened only on click, stayed open until the same
  summary was clicked again, ignored Escape, ignored a click anywhere else on the
  page, and let two panels sit open at once. On a desktop nav that reads as an
  unfinished browser widget rather than a menu, which is what "the dropdowns are
  not redesigned" describes.

  What this adds, and nothing more:
    - open on hover, on pointers that actually hover, with a small intent delay so
      crossing the bar does not flash three panels;
    - close on Escape, with focus returned to the trigger;
    - close on a click or a focus that lands outside;
    - one panel open at a time;
    - aria-expanded on the summary, because <details> alone does not tell every
      screen reader what it is looking at.

  Keyboard and click behaviour are unchanged: <details> already toggles on Enter,
  Space and click, and none of that is intercepted here. With JavaScript off the
  menu is still a working disclosure widget.
*/
(function () {
  'use strict';

  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 220;

  var drops = [].slice.call(document.querySelectorAll('.am-drop'));
  if (!drops.length) return;

  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var timers = new WeakMap();

  function summaryOf(d) { return d.querySelector('summary'); }

  function setExpanded(d) {
    var s = summaryOf(d);
    if (s) s.setAttribute('aria-expanded', d.hasAttribute('open') ? 'true' : 'false');
  }

  function close(d) {
    if (!d.hasAttribute('open')) return;
    d.removeAttribute('open');
    setExpanded(d);
  }

  function closeAll(except) {
    for (var i = 0; i < drops.length; i++) if (drops[i] !== except) close(drops[i]);
  }

  function open(d) {
    closeAll(d);
    d.setAttribute('open', '');
    setExpanded(d);
  }

  function cancel(d) {
    var t = timers.get(d);
    if (t) { window.clearTimeout(t); timers.delete(d); }
  }

  drops.forEach(function (d) {
    var s = summaryOf(d);
    setExpanded(d);

    /* Clicking the summary is <details>'s own job; all this does is make sure the
       other panels do not stay behind, and that aria-expanded follows the state
       after the browser has flipped it. */
    if (s) {
      s.addEventListener('click', function () {
        var wasOpen = d.hasAttribute('open');
        window.setTimeout(function () {
          if (!wasOpen) closeAll(d);
          setExpanded(d);
        }, 0);
      });
    }

    if (canHover) {
      d.addEventListener('mouseenter', function () {
        cancel(d);
        timers.set(d, window.setTimeout(function () { open(d); }, OPEN_DELAY));
      });
      d.addEventListener('mouseleave', function () {
        cancel(d);
        timers.set(d, window.setTimeout(function () { close(d); }, CLOSE_DELAY));
      });
    }

    /* Tabbing out of the panel closes it. `relatedTarget` is null when focus
       leaves the document entirely, and that is not a reason to close. */
    d.addEventListener('focusout', function (event) {
      if (event.relatedTarget && !d.contains(event.relatedTarget)) close(d);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    for (var i = 0; i < drops.length; i++) {
      if (drops[i].hasAttribute('open')) {
        var s = summaryOf(drops[i]);
        close(drops[i]);
        if (s && drops[i].contains(document.activeElement)) s.focus();
      }
    }
  });

  document.addEventListener('click', function (event) {
    for (var i = 0; i < drops.length; i++) {
      if (drops[i].hasAttribute('open') && !drops[i].contains(event.target)) close(drops[i]);
    }
  });
})();
